import React from "react";
import { Box, Paper, Typography, Chip } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import RemoveIcon from "@mui/icons-material/Remove";

const badgeColors = { GREEN: "#22c55e", YELLOW: "#f59e0b", RED: "#ef4444" };
const trendIcons = {
  improving: <TrendingUpIcon sx={{ fontSize: 16, color: "#22c55e" }} />,
  declining: <TrendingDownIcon sx={{ fontSize: 16, color: "#ef4444" }} />,
  stable: <RemoveIcon sx={{ fontSize: 16, color: "#64748b" }} />,
};

export default function HealthWidget({ data }) {
  if (!data) return null;
  const { overall, badge, trend, breakdown } = data;

  return (
    <Paper className="glass-card" sx={{ p: 3 }}>
      <Typography fontWeight={700} fontSize={15} color="#1e293b" mb={2}>
        Account Health
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
        <Box sx={{ position: "relative", width: 72, height: 72 }}>
          <svg viewBox="0 0 36 36" style={{ transform: "rotate(-90deg)" }}>
            <path
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none" stroke="#e2e8f0" strokeWidth="3"
            />
            <path
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              fill="none" stroke={badgeColors[badge]} strokeWidth="3"
              strokeDasharray={`${overall}, 100`}
            />
          </svg>
          <Box sx={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Typography fontWeight={800} fontSize={18} color="#1e293b">{overall}</Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
          <Chip label={badge} size="small"
            sx={{ color: "#fff", bgcolor: badgeColors[badge], fontWeight: 700, width: 70 }} />
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {trendIcons[trend]}
            <Typography variant="caption" color="#64748b" fontWeight={600}>{trend}</Typography>
          </Box>
        </Box>
      </Box>
      {breakdown && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {Object.entries(breakdown).map(([key, val]) => (
            <Box key={key} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <Typography variant="body2" color="#475569" fontWeight={500}
                sx={{ textTransform: "capitalize" }}>
                {key.replace(/([A-Z])/g, " $1")}
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Box sx={{ width: 60, height: 6, borderRadius: 3, bgcolor: "#e2e8f0", overflow: "hidden" }}>
                  <Box sx={{
                    width: `${(val.score / val.max) * 100}%`, height: "100%", borderRadius: 3,
                    bgcolor: val.score / val.max > 0.7 ? "#22c55e" : val.score / val.max > 0.4 ? "#f59e0b" : "#ef4444",
                  }} />
                </Box>
                <Typography variant="caption" color="#64748b" fontWeight={600}
                  sx={{ minWidth: 28, textAlign: "right" }}>
                  {val.score}/{val.max}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      )}
    </Paper>
  );
}
